import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*@__PURE__*/_defineComponent({
  __name: 'OutlineButton',
  props: {
    isLoading: { type: Boolean },
    btnText: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {



const emits = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["border border-brown rounded-lg", {
      'opacity-25 pointer-events-none': __props.isLoading,
    }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('click')))
  }, _toDisplayString(__props.btnText), 3))
}
}

})